<template>
  <!-- 数据统计时间筛选组件 -->
  <div class="page">
    <section class="info-wrap">
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px">
        <el-form-item label="证件类型" prop="idDocType">
          <el-select v-model="ruleForm.idDocType" placeholder="">
            <el-option v-for="item in idDocTypeList" :key="item.id" :label="item.name" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="style" label="身份证人像面照片" prop="idCardInfoIdCardCopy">
          <div class="img-wrap">
            <div class="img-list">
              <el-upload
                :class="ruleForm.idCardInfoIdCardCopy && ruleForm.idCardInfoIdCardCopy.length > 0 ? 'hide' : ''"
                list-type="picture-card"
                :file-list="imgList"
                :action="$configUrl.uploadUrl"
                :on-remove="handleRemove"
                :on-success="
                  (response, file, fileList) => {
                    return idCardInfoIdCardCopySuccess(file, fileList);
                  }
                "
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="style" label="身份证国徽面照片" prop="idCardInfoIdCardNational">
          <div class="img-wrap">
            <div class="img-list">
              <el-upload
                :class="ruleForm.idCardInfoIdCardNational && ruleForm.idCardInfoIdCardNational.length > 0 ? 'hide' : ''"
                list-type="picture-card"
                :file-list="nationalList"
                :action="$configUrl.uploadUrl"
                :on-remove="handleRemove1"
                :on-success="
                  (response, file, fileList) => {
                    return idCardInfoIdCardNationalSuccess(file, fileList);
                  }
                "
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="style" label="身份证姓名" prop="idCardName">
          <el-input v-model="ruleForm.idCardName" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item label="身份证号码" prop="idCardNumber">
          <el-input v-model="ruleForm.idCardNumber" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item class="style" prop="type" label="证件有效期类型">
          <div>
            <el-radio-group v-model="ruleForm.type">
              <el-radio :label="0">固定有效期</el-radio>
              <el-radio :label="1">长期有效</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="有效期限开始日期" prop="cardPeriodBegin">
          <el-date-picker
            v-model="ruleForm.cardPeriodBegin"
            type="date"
            placeholder="选择日期"
            clearable
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item v-if="ruleForm.type === 0" label="有效期限结束日期" prop="cardPeriodEnd">
          <el-date-picker
            v-model="ruleForm.cardPeriodEnd"
            type="date"
            placeholder="选择日期"
            clearable
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item v-if="id != 2" class="style" prop="owner" label="是否为受益人">
          <div>
            <el-radio-group v-model="ruleForm.owner" @change="changeOwner">
              <el-radio :label="0">是</el-radio>
              <el-radio :label="1">否</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number || Boolean,
      default: false,
    },
    subjectData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      imgList: [],
      nationalList: [],
      ruleForm: {
        idDocType: 'IDENTIFICATION_TYPE_IDCARD',
        idCardInfoIdCardCopy: [],
        idCardInfoIdCardNational: [],
        idCardName: '',
        idCardNumber: '',
        cardPeriodBegin: '',
        cardPeriodEnd: '',
        owner: 0,
        type: 0,
      },
      rules: {
        idDocType: [{ required: true, message: '', trigger: ['blur', 'change'] }],
        type: [{ required: true, message: '', trigger: ['blur', 'change'] }],
        idCardInfoIdCardCopy: [{ required: true, message: '请上传人身面照片', trigger: ['blur', 'change'] }],
        idCardInfoIdCardNational: [{ required: true, message: '请上传国徽面照片', trigger: ['blur', 'change'] }],
        idCardName: [{ required: true, message: '请输入身份证姓名', trigger: ['blur', 'change'] }],
        idCardNumber: [{ required: true, message: '请输入身份证号码', trigger: ['blur', 'change'] }],
        cardPeriodBegin: [{ required: true, message: '请选择有效期限开始日期', trigger: ['blur', 'change'] }],
        cardPeriodEnd: [{ required: true, message: '请选择有效期限结束日期', trigger: ['blur', 'change'] }],
        owner: [{ required: true, message: '请选择是否为受益人', trigger: ['blur', 'change'] }],
      },
      idDocTypeList: [
        {
          id: 0,
          name: '中国大陆居民-身份证',
          value: 'IDENTIFICATION_TYPE_IDCARD',
        },
        {
          id: 1,
          name: '中国香港居民-来往内地通行证',
          value: 'IDENTIFICATION_TYPE_HONGKONG_PASSPORT',
        },
        {
          id: 2,
          name: '中国澳门居民-来往内地通行证',
          value: 'IDENTIFICATION_TYPE_MACAO_PASSPORT',
        },
        {
          id: 3,
          name: '中国台湾居民-来往大陆通行证',
          value: 'IDENTIFICATION_TYPE_TAIWAN_PASSPORT',
        },
        {
          id: 4,
          name: '其他国家或地区居民-护照',
          value: 'IDENTIFICATION_TYPE_OVERSEA_PASSPORT',
        },
      ],
      cardPeriodEnType: false,
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
  },
  watch: {
    count: {
      handler: function () {
        this.validity();
      },
    },
    subjectData: {
      handler: function (data) {
        console.log(data);
        this.ruleForm = data.subjectDataVO;
        let idCardInfoIdCardCopyList = data.subjectDataVO.idCardInfoIdCardCopy.split(',');
        let idCardInfoIdCardNationalList = data.subjectDataVO.idCardInfoIdCardNational.split(',');
        this.imgList = idCardInfoIdCardCopyList.map((item) => {
          const fileItem = {
            name: 'file',
            url: item,
            response: {
              data: item,
            },
          };
          return fileItem;
        });
        this.nationalList = idCardInfoIdCardNationalList.map((item) => {
          const fileItem = {
            name: 'file',
            url: item,
            response: {
              data: item,
            },
          };
          return fileItem;
        });
        if (data.subjectDataVO.cardPeriodEnd !== '') {
          this.ruleForm.type = 0;
        } else {
          this.ruleForm.type = 1;
        }
        if (data.subjectDataVO.name !== '') {
          this.ruleForm.owner = 1;
          this.changeOwner();
        } else {
          this.ruleForm.owner = 0;
          this.changeOwner();
        }
      },
    },
  },

  methods: {
    idCardInfoIdCardCopySuccess(file, fileList) {
      console.log(file, fileList);
      this.ruleForm.idCardInfoIdCardCopy = file.response.data.url;
      console.log(this.ruleForm.idCardInfoIdCardCopy);
      this.$emit('handleMediaIdCard1', this.ruleForm.idCardInfoIdCardCopy,file.name);
    },
    idCardInfoIdCardNationalSuccess(file, fileList) {
      console.log(file, fileList);
      this.ruleForm.idCardInfoIdCardNational = file.response.data.url;
      console.log(this.ruleForm.idCardInfoIdCardNational);
      this.$emit('handleMediaIdCard2', this.ruleForm.idCardInfoIdCardNational,file.name);
    },
    changeOwner() {
      this.$emit('changeOwner', this.ruleForm.owner);
    },
    handleRemove() {
      this.ruleForm.idCardInfoIdCardCopy = [];
    },
    handleRemove1() {
      this.ruleForm.idCardInfoIdCardNational = [];
    },
    validity() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('confirm', { flag: true, ruleForm: this.ruleForm });
          console.log('验证通过');
        } else {
          this.$emit('confirm', { flag: false, ruleForm: this.ruleForm });
          console.log('验证失败');
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.info-wrap {
  box-sizing: border-box;
  padding-left: 31px;
}
.img-wrap {
  width: 700px;
  .img-list {
    height: 80px;
    overflow: hidden;
  }
  .hint {
    font-size: 12px;
    transform-origin: left;
    transform: scale(0.9);
    color: #fe4b48;
    margin-bottom: 5px;
  }
  /deep/ .el-upload--picture-card {
    width: 58px;
    height: 58px;
    line-height: 58px;
  }
  /deep/ .el-upload-list {
    /deep/.el-upload-list__item.is-success:first-child {
      &::before {
        position: absolute;
        left: 0;
        top: 0;
        content: '主图';
        color: #fff;
        width: 100%;
        height: 22px;
        font-size: 12px;
        text-align: center;
        line-height: 22px;
        background: rgba(0, 0, 0, 0.36);
      }
    }
  }
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
    box-sizing: border-box;
  }
  /deep/ .el-upload--picture-card i {
    font-size: 14px;
  }
  /deep/ .el-upload-list__item-actions {
    width: 80px;
    height: 80px;
  }
  .hide {
    /deep/ .el-upload.el-upload--picture-card {
      display: none;
    }
  }
}
.labels-tips {
  font-size: 12px;
  font-weight: 500;
  color: #999999;
}
/deep/.el-input {
  width: 346px;
}
</style>
